export default __webpack_public_path__ + "static/media/1.5c1e3022.jpg";